module.exports = __webpack_public_path__ + "src/assets/img/ramblersearch.f911afb1.jpg";